/**
 * WaterfallChartEditor
 *
 * Property editor for waterfall chart configuration
 */

import React from 'react';
import { ChartBaseEditor, type ChartBaseConfig } from './ChartBaseEditor';
import { TextPropertyEditor } from '../../BaseEditors/TextPropertyEditor';

export interface WaterfallChartEditorProps {
  config: Partial<ChartBaseConfig & {
    labelKey?: string;
    valueKey?: string;
    showConnector?: boolean;
  }>;
  onChange: (config: Partial<ChartBaseConfig>) => void;
}

export const WaterfallChartEditor: React.FC<WaterfallChartEditorProps> = ({ config, onChange }) => {
  return (
    <ChartBaseEditor config={config} onChange={onChange} chartType="Waterfall Chart" showAxes>
      <div className="chart-editor__section">
        <h3 className="chart-editor__section-title">Waterfall Options</h3>

        <TextPropertyEditor
          label="Label Key"
          value={(config.labelKey as string) || 'label'}
          onChange={(labelKey) => onChange({ ...config, labelKey })}
          helpText="Property for step labels"
          required
        />

        <TextPropertyEditor
          label="Value Key"
          value={(config.valueKey as string) || 'value'}
          onChange={(valueKey) => onChange({ ...config, valueKey })}
          helpText="Property for change values"
          required
        />

        <div className="chart-editor__checkbox">
          <input
            type="checkbox"
            id="show-connector"
            checked={(config.showConnector as boolean) !== false}
            onChange={(e) => onChange({ ...config, showConnector: e.target.checked })}
            className="af-property-editor__checkbox"
          />
          <label htmlFor="show-connector">Show Connector Lines</label>
        </div>
      </div>
    </ChartBaseEditor>
  );
};

WaterfallChartEditor.displayName = 'WaterfallChartEditor';
